import { Divider } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export default withStyles((theme) => ({
  root: {
    backgroundColor: theme.colors.greyE8,
  },
  absolute: {},
  inset: {},
  light: {},
  middle: {},
  vertical: {},
  flexItem: {},
}))(Divider);
